"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SwitchPaymentType_1 = __importDefault(require("./SwitchPaymentType"));
var Header = function (_a) {
    var _b;
    var balanceData = _a.balanceData, isFailed = _a.isFailed;
    var t = (0, next_intl_1.useTranslations)('translation');
    var config = (0, swr_hooks_1.useConfig)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.modalHeader }, isFailed ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.failed },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.failedTitle }, t('depositFailedTitle')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.failedDescr, dangerouslySetInnerHTML: {
                __html: (config === null || config === void 0 ? void 0 : config.supportEmail)
                    ? t('depositFailedDescr', {
                        support: "<a href=\"mailto:".concat(config === null || config === void 0 ? void 0 : config.supportEmail, "\">").concat(config === null || config === void 0 ? void 0 : config.supportEmail, "</a>"),
                    })
                    : t('depositFailedDescr'),
            } }))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.balance },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.balanceTitle }, t('balance')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.totalBalance }, balanceData
                    ? "".concat((0, apps_shared_1.getCurrencySymbol)(balanceData === null || balanceData === void 0 ? void 0 : balanceData.currency)).concat((_b = Number(balanceData === null || balanceData === void 0 ? void 0 : balanceData.totalAmount)) === null || _b === void 0 ? void 0 : _b.toFixed(2))
                    : ''))),
        react_1.default.createElement(SwitchPaymentType_1.default, null)))));
};
exports.default = Header;
